import { $FixMe } from 'types';
import { useMemo, ReactNode } from 'react';
import { toaster } from '../ui/toaster';

/**
 * @description
 * A small abstraction over the Chakra useToast hook to add some defaults.
 * @returns a toast function which can be used to show a toast and customize toast options through the function param.
 */
export default function useAlituToast() {
  return useMemo(() => {
    return {
      render: (
        options: $FixMe & {
          title: string;
          type?: string;
          action?: { label: string; onClick: () => void };
          duration?: number;
          icon?: ReactNode;
          onClick?: () => void;
          isClosable?: boolean;
        },
      ) =>
        toaster.create({
          meta: {
            closable: true,
          },
          placement: 'bottom-left',
          ...options,
        }),
      close: (toastId: string) => {
        toaster.dismiss(toastId);
      },
      closeAll: () => {
        toaster.dismiss();
      },
    };
  }, []);
}
